import { render, staticRenderFns } from "./FacultiesDropDown.vue?vue&type=template&id=4ed0433d&"
import script from "./FacultiesDropDown.vue?vue&type=script&lang=js&"
export * from "./FacultiesDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports